<div class="row margin-bottom">
  <div class="col-md-12">
    <a class="btn button-default" [routerLink]="['/sites/list']"><i class="fa fa-chevron-left text-positive"></i>back to sites list</a>
  </div>
</div>
<router-outlet></router-outlet>
